import { IEventDefinition } from "@highway/mbs-analytics";

export const appEvents: Record<string, IEventDefinition> = {
    appreciation_calc_calculate_click: {
        description: 'Fires when the user clicks "Calculate" after entering inputs.',
        mappings: {
            mixpanel: "appreciation_calc_calculate_click",
        },
    },
    appreciation_calc_calculate_success: {
        description: "Fires when the report is successfully generated.",
        mappings: {
            mixpanel: "appreciation_calc_calculate_success",
        },
    },
    hpi_tab_click: {
        description: "Fires when the user switches between HPI tabs.",
        mappings: {
            mixpanel: "hpi_tab_click",
        },
    },
    boa_calculate_click: {
        description: 'Fires when the user clicks "Calculate" button.',
        mappings: {
            mixpanel: "boa_calculate_click",
        },
    },
    boa_calculate_success: {
        description: 'Fires when the user clicks "Calculate" button if the report is valid and saves.',
        mappings: {
            mixpanel: "boa_calculate_success",
        },
    },
    bvr_purchase_price_page_view: {
        description: "Fires when the user lands on the Purchase Price flow.",
        mappings: {
            mixpanel: "bvr_purchase_price_page_view",
        },
    },
    bvr_desired_payment_page_view: {
        description: "Fires when the user lands on the Desired Monthly Payment flow.",
        mappings: {
            mixpanel: "bvr_desired_payment_page_view",
        },
    },
    bvr_military_bah_page_view: {
        description: "Fires when the user lands on the Military BAH flow.",
        mappings: {
            mixpanel: "bvr_military_bah_page_view",
        },
    },
    bvr_purchase_price_calculate_click: {
        description: 'Fires when the user clicks "Next" on the Purchase Price flow.',
        mappings: {
            mixpanel: "bvr_purchase_price_calculate_click",
        },
    },
    bvr_desired_payment_calculate_click: {
        description: 'Fires when the user clicks "Next" on the Desired Monthly Payment flow.',
        mappings: {
            mixpanel: "bvr_desired_payment_calculate_click",
        },
    },
    bvr_military_bah_calculate_click: {
        description: 'Fires when the user clicks "Next" on the Military BAH flow.',
        mappings: {
            mixpanel: "bvr_military_bah_calculate_click",
        },
    },
    bvr_purchase_price_calculate_success: {
        description: "Fires when the Purchase Price flow is valid and saves.",
        mappings: {
            mixpanel: "bvr_purchase_price_calculate_success",
        },
    },
    bvr_desired_payment_calculate_success: {
        description: "Fires when the Desired Monthly Payment flow is valid and saves.",
        mappings: {
            mixpanel: "bvr_desired_payment_calculate_success",
        },
    },
    bvr_military_bah_calculate_success: {
        description: "Fires when the Military BAH flow is valid and saves.",
        mappings: {
            mixpanel: "bvr_military_bah_calculate_success",
        },
    },
    mbestimate_page_view: {
        description: "Fires when the MBe$timate tool/page is opened.",
        mappings: {
            mixpanel: "mbestimate_page_view",
        },
        validTools: ["mbe"],
    },
    mbestimate_location_entered: {
        description: "Fires when the user enters/selects a property location.",
        mappings: {
            mixpanel: "mbestimate_location_entered",
        },
        validTools: ["mbe"],
    },
    mbestimate_get_value_click: {
        description: 'Fires when the user clicks "Get value" to generate the estimate.',
        mappings: {
            mixpanel: "mbestimate_get_value_click",
        },
        validTools: ["mbe"],
    },
    mbestimate_get_value_success: {
        description: "Fires when the value estimate/report is successfully generated.",
        mappings: {
            mixpanel: "mbestimate_get_value_success",
        },
        validTools: ["mbe"],
    },
    mbestimate_download_click: {
        description: "Fires when the user downloads the estimate PDF.",
        mappings: {
            mixpanel: "mbestimate_download_click",
        },
        validTools: ["mbe"],
    },
};
